<template>
  <div
    class="sm:w-[calc(100%-360px)] md:relative md:flex md:w-[calc(100%-490px)] md:pl-[113px] xl:w-[57.8125%] 3xl:w-[57.95%] 3xl:pl-[153px]"
  >
    <div
      class="relative mb-2 aspect-[375/312] w-full sm:max-h-[500px] md:order-last md:mb-0 xl:aspect-[664/552] xl:max-h-full 3xl:aspect-[904/750]"
    >
      <swiper-container
        v-show="isSwiperMainInit"
        ref="swiperMainEl"
        init="false"
        class="h-full w-full transition"
      >
        <swiper-slide
          v-for="(image, i) in images"
          :key="i"
          class="flex items-center justify-center"
        >
          <CdnImg
            :src="handleImageSrc(image)"
            :alt="handleImageAlt(image)"
            loading="lazy"
            class="h-full w-full object-contain"
            :width="900"
            :height="900"
          />
        </swiper-slide>
      </swiper-container>
    </div>

    <swiper-container
      v-show="isSwiperThumbsInit"
      ref="swiperThumbsEl"
      init="false"
      class="w-full transition md:!absolute md:bottom-0 md:left-0 md:top-0 md:mr-4 md:w-[97px] 3xl:w-[137px]"
    >
      <swiper-slide
        v-for="(image, i) in images"
        :key="i"
        class="relative flex h-[58px] w-[70px] cursor-pointer items-center justify-center md:h-[80px] md:w-[97px] 3xl:h-[113px] 3xl:w-[137px]"
        @click="slideTo(i)"
      >
        <CdnImg
          :src="handleImageSrc(image)"
          :alt="handleImageAlt(image)"
          loading="lazy"
          class="h-full w-full object-contain"
          :width="137"
          :height="137"
        />
      </swiper-slide>
    </swiper-container>
  </div>
</template>

<script setup lang="ts">
import { nextTick, onMounted, ref } from 'vue';
import { CdnImg } from '@webplatform/cdn-image';
import { handleImageSrc, handleImageAlt } from '~/helpers';
import { useSwiperElement } from '~/composables';

interface Props {
  images?: any;
}

withDefaults(defineProps<Props>(), {
  images: () => [],
});

const isSwiperMainInit = ref(false);
const isSwiperThumbsInit = ref(false);

const swiperMainEl = useSwiperElement({
  on: {
    init: () => {
      isSwiperMainInit.value = true;
    },
  },
});

const swiperThumbsEl = useSwiperElement({
  slidesPerView: 'auto',
  spaceBetween: 16,
  loop: false,
  breakpoints: {
    1024: {
      direction: 'vertical',
      spaceBetween: 8,
    },
  },
  on: {
    init: () => {
      isSwiperThumbsInit.value = true;
    },
  },
});

onMounted(() => {
  nextTick(() => {
    const main = swiperMainEl.value?.swiper;
    const thumbs = swiperThumbsEl.value?.swiper;
    // destroy() снимает модули с инстанса, если элемент уже успели убрать из DOM
    if (!main || main.destroyed || !thumbs || thumbs.destroyed) return;

    main.controller.control = thumbs;
    thumbs.controller.control = main;
  });
});

const slideTo = (i: number) => {
  swiperMainEl.value?.swiper?.slideTo(i);
};
</script>
